import React, { useEffect, useState } from 'react';
import './midcontent.scss';
import { useParams, useLocation, Link } from 'react-router-dom';
import useProducts from '../Admin/useProducts';
import Filtercontroller from './Filtercontroller';
import Loader from '../Loader/Loader';
import CartModal from "../Mainpage/CartModal";
import { HeartFill } from 'react-bootstrap-icons';
import LoginModal from '../Mainpage/LoginModal';
import Swal from 'sweetalert2';
import Cookies from 'universal-cookie';
import useFetchWishlist from '../Admin/useFetchWishlist';

const cookies = new Cookies();

const Home = () => {
  const location = useLocation();
  const isRootPath = location.pathname === '/';
  const queryParams = new URLSearchParams(location.search);

  const category_code = queryParams.get('category');
  const guide = queryParams.get('guide');
  const price_min = queryParams.get('price_min');
  const price_max = queryParams.get('price_max');
  const jewellery_type = queryParams.get('jewellery_type');

  const [showCart, setShowCart] = useState(false);
  const [loginShow, setLoginShow] = useState(false);

  const [filters, setFilters] = useState({
    category_code: category_code || '',
    product_guide: guide || '',
    jewellery_type: jewellery_type || '',
    price_min: price_min || '',
    price_max: price_max || '',
    per_page: '',
  });

  const { products, currentPage, lastPage, load, err, fetchproducts } = useProducts(filters);
  const { wishlistElements, fetchWishlist } = useFetchWishlist();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [products]);

  useEffect(() => {
    setFilters(prevFilters => ({
      ...prevFilters,
      price_min: price_min || 0,
      price_max: price_max || 1000,
      category_code: category_code || '',
      product_guide: guide || '',
    }));
  }, [category_code, guide, price_min, price_max]);

  useEffect(() => {
    fetchproducts();
  }, [filters]);

  const handleShowLogin = () => setLoginShow(true);
  const handleClose = () => {
    setLoginShow(false);
    setShowCart(false);
  };
  const handleShowCart = () => setShowCart(true);


  const generatePageNumbers = (currentPage, lastPage) => {
    const pages = [];
    const startPage = Math.max(1, currentPage - 2);
    const endPage = Math.min(lastPage, currentPage + 2);

    if (startPage > 1) {
      pages.push(1);
      if (startPage > 2) pages.push('...');
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }

    if (endPage < lastPage) {
      if (endPage < lastPage - 1) pages.push('...');
      pages.push(lastPage);
    }

    return pages;
  };

  const handlePageClick = (pageNumber) => {
    fetchproducts(pageNumber);
  };

  const addtocart = async (variant_id, e, product_code) => {
    const token = localStorage.getItem("token");
    const user_id = localStorage.getItem("user_id") || "";
    const common_id = localStorage.getItem("common_id") || "";

    if (variant_id != null) {
      try {
        const response = await fetch(`https://backend.indianjewelryish.com/api/cart/add`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            common_id,
            user_id: parseInt(user_id),
            product_code,
            quantity: 1,
            variant_id,
          }),
        });

        if (!response.ok) throw new Error("Network response was not ok");

        const data = await response.json();

        if (data.full) {
          alert("Quantity reached");
        }

        handleShowCart();

        if (data.cart.common_id) {
          localStorage.setItem("common_id", data.cart.common_id);
        }
      } catch (error) {
        if (token || user_id) {
          console.error("Error adding to cart:", error);
        } else {
          localStorage.clear();
          cookies.remove("user_id");
          handleShowLogin();
        }
      }
    } else {
      Swal.fire({
        icon: "warning",
        confirmButtonColor: "#b63f23",
        title: "Select Variant!",
      });
    }
  };

  const wishlistAdd = async (product_code) => {
    const token = localStorage.getItem('token');
    const user_id = localStorage.getItem('user_id') || '';

    try {
      const response = await fetch(`https://backend.indianjewelryish.com/api/add-whishlist`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ user_id: parseInt(user_id), product_code }),
      });

      if (!response.ok) throw new Error('Network response was not ok');

      const data = await response.json();
      const wishlistElement = document.querySelector('.' + product_code);

      if (data.success) {
        wishlistElement.style.color = 'red';
      } else if (data.remove) {
        wishlistElement.style.color = '#11111199';
      }

    } catch (error) {
      if (token || user_id) {
        Swal.fire({
          icon: 'warning',
          confirmButtonColor: '#b63f23',
          title: 'There seems to be an issue adding the item to the wishlist.',
        });
      } else {
        localStorage.clear();
        cookies.remove('user_id');
        handleShowLogin();
      }
    }
  };

  if (load) {
    return <div><Loader /></div>;
  }
  console.log('Products:', products)
  return (
    <>
      {!isRootPath && <Filtercontroller />}
      <section id='midcontent'>
        {products.map((product) => (
          <div key={product.id} className="card">
            {product?.product_discount && (
              <span className='sale-banner'>
                Sale
              </span>
            )}
            <button
              style={wishlistElements.includes(product.product_code) ? { color: 'red' } : { color: '#11111199' }}
              onClick={() => wishlistAdd(product.product_code)}
              id='wishlistoutside'
              className={product.product_code}
            >
              <HeartFill size={20} />
            </button>

            <Link to={`/productshow/${product.product_code}`}>
              <div className='image-container'>
                <img
                  src={`https://backend.indianjewelryish.com/${product.product_image_1}`}
                  alt={product.product_name}
                />
              </div>
              <h3>{product.product_name}</h3>
              <p className="price">
                ${(product?.variant?.price * (1 - product.product_discount / 100)).toFixed(2)}
                {product?.product_discount && (
                  <span className="price-cut-home">${product?.variant?.price}</span>
                )}
              </p>
              <div className="d-flex justify-content-center p-0 m-0">
                {Array.from({ length: 5 }).map((_, index) => (
                  <span style={{ fontSize: "14px" }} className='rating-star' key={index}>
                    {product.top_review && index < product.top_review.rating ? '★' : '☆'}
                  </span>
                ))}
              </div>
            </Link>


            <div className="d-flex align-items-center justify-content-center">
              {product?.single_product == 1 ? (
                <button
                  className='loginsignupbutton'
                  onClick={(e) => addtocart(product?.variant?.id, e, product?.product_code)}
                  style={{ width: "90%", height: "47px" }}
                >
                  Add to Cart
                </button>
              ) : (
                <Link to={`/productshow/${product.product_code}`} style={{ width: "100%" }}>
                  <button className='loginsignupbutton' style={{ width: "90%", height: "47px" }}>
                    Add Variant
                  </button>
                </Link>
              )}
            </div>

            {product?.variant?.quantity === 0 && product?.single_product > 0 ? (
              <p className="discount mt-2">Out of stock!</p>
            ) : (
              product?.variant?.quantity < 15 && product?.single_product > 0 && (
                <p className="discount mt-2">Only {product?.variant?.quantity} left!</p>
              )
            )}
          </div>
        ))}
      </section>

      <div className="pagination">
        {generatePageNumbers(currentPage, lastPage).map((pageNumber, index) => (
          <button
            key={index}
            onClick={() => typeof pageNumber === 'number' && handlePageClick(pageNumber)}
            disabled={pageNumber === currentPage}
          >
            {pageNumber}
          </button>
        ))}
      </div>

      <LoginModal show={loginShow} onClose={handleClose} />
      <CartModal show={showCart} onClose={handleClose} />
    </>
  );
};

export default Home;
